import React from "react";
import Checkbox from "./Checkbox";

const UnitTypeCheckboxes = ({ onChangeUnitCheck, unitTypes, unitType }) => {
  return (
    <div className="unit-type-box">
      <div className="unit-text">Unit Type:</div>
      <div className="unit-type-check">
        <Checkbox
          id="SF"
          inputName="SF"
          label="STUDIO"
          checkType={onChangeUnitCheck}
          checkVal={unitTypes}
          disabled={unitType === "SF"}
        />
        <Checkbox
          id="1F"
          inputName="1F"
          label="1 Bedroom"
          checkType={onChangeUnitCheck}
          checkVal={unitTypes}
          disabled={unitType === "1F"}
        />
        <Checkbox
          id="2F"
          inputName="2F"
          label="2 Bedroom"
          checkType={onChangeUnitCheck}
          checkVal={unitTypes}
          disabled={unitType === "2F"}
        />
        <Checkbox
          id="3F"
          inputName="3F"
          label="3 Bedroom"
          checkType={onChangeUnitCheck}
          checkVal={unitTypes}
          disabled={unitType === "3F"}
        />
      </div>
    </div>
  );
};

export default UnitTypeCheckboxes;
